export default "__VITE_ASSET__DYGzOV3___"